<!--业务组件：预览原型页右侧工具栏，横屏状态下在屏幕顶部显示
    @small,dengli
    @date 2018.3.26
-->
<template>
    <div :class="{ show: show, slider_bar_port: slideBarOrient.portrait, slider_bar_land: slideBarOrient.landscape }">
        <ul>
            <li
                class="slide-item"
                @click="goTo(item)"
                :class="[item.cls]"
                v-for="(item, index) in filterList"
                :key="index"
            >
                <span>{{ item.name }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "slideBar",
    props: {
        show: {
            default() {
                return false
            }
        },
        pageShare: {
            type: Boolean,
            default: true
        },
        homeId: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            sharePage: true, //是否为移动端浏览器打开的线上分享页面
            slideBarOrient: {
                portrait: true,
                landscape: false
            }
        }
    },
    computed: {
        list() {
            if (this.pageShare) {
                return [{ name: "返回首页", cls: "proto_home" }, { name: "上一页", cls: "prev_btn" }]
            } else {
                return [
                    { name: "返回首页", cls: "proto_home" },
                    { name: "上一页", cls: "prev_btn" },
                    { name: "分享", cls: "share_btn" },
                    { name: "打点评论", cls: "comment_btn" },
                    { name: "显示状态栏", cls: "statusbar_btn_show" },
                    { name: "关闭原型", cls: "proto_close" }
                ]
            }
        },
        filterList() {
            var temp = []
            this.list.forEach(item => {
                if (
                    item.name !== "分享" && item.name !== "显示状态栏" && item.name !== "隐藏状态栏"
                        ? true
                        : this.sharePage
                        ? true
                        : false
                ) {
                    temp.push(item)
                }
            })
            return temp
        }
    },
    mounted() {
        this.sharePage = window.isWebview
        this.orient()
    },
    destroyed() {
        this.rmOrient()
    },
    methods: {
        //旋屏相关
        orient() {
            screen.orientation.addEventListener("change", this.judgeOrient, false)
        },
        rmOrient() {
            screen.orientation.removeEventListener("change", this.judgeOrient, false)
            console.log("[移除屏幕方向监听事件]")
        },
        judgeOrient() {
            if (screen.orientation.type.includes("portrait")) {
                this.slideBarOrient.portrait = true
                this.slideBarOrient.landscape = false
            } else {
                this.slideBarOrient.portrait = false
                this.slideBarOrient.landscape = true
            }
        },
        goTo(item) {
            if (item.cls == "prev_btn") {
                this.$router.go(-1)
                this.$parent.$refs["proto"].goback = false
                this.$parent.$refs["proto"].banSliderbarGoBackanimate = true
            } else if (item.cls == "proto_home") {
                this.$parent.$refs["proto"].goback = false
                this.$parent.$refs["proto"].banSliderbarGoBackanimate = true
                if (this.homeId) {
                    if (this.pageShare) {
                        this.$router.push({
                            name: "share",
                            query: {
                                id: this.homeId,
                                team_id: this.$route.query.team_id
                            }
                        })
                    } else {
                        this.$router.push({
                            name: "proto",
                            query: {
                                image_id: this.homeId,
                                project_id: this.$route.query.project_id,
                                project_name: this.$route.query.project_name
                            }
                        })
                    }
                } else {
                    this.$root.eventBus.$emit("showTip", "项目没有主页", "normal")
                }
            } else if (item.cls == "proto_close") {
                this.$router.push({
                    name: "design",
                    query: {
                        project_id: this.$route.query.project_id,
                        project_name: this.$route.query.project_name,
                        image_id: this.$route.query.image_id
                    }
                })
            } else if (item.cls == "share_btn") {
                this.$emit("share")
            } else if (item.cls == "statusbar_btn_show") {
                this.list[4].name = "隐藏状态栏"
                this.list[4].cls = "statusbar_btn_hide"
                StatusBar.show()
            } else if (item.cls == "statusbar_btn_hide") {
                this.list[4].name = "显示状态栏"
                this.list[4].cls = "statusbar_btn_show"
                StatusBar.hide()
            } else if (item.cls == "comment_btn") {
                this.$router.push({
                    name: "comment",
                    query: this.$route.query
                })
            }
            this.$emit("close")
        }
    }
}
</script>

<style lang="scss" scoped>
.slider_bar_port {
    height: 100vh;
    width: 6.25rem;
    background: rgba(255, 255, 255, 0.9);
    position: fixed;
    left: 0;
    top: 0;
    transform: translateX(-100%);
    z-index: 111;
    transition: all ease 200ms;

    &.show {
        transform: translateX(0);
        z-index: 2018;
    }
    ul {
        width: 100%;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
        li {
            width: 6.25rem;
            height: 4.8rem;
            position: relative;
            &.proto_home {
                background: url("~@/assets/imgs/bar_home.png") center 1rem / 1.6rem no-repeat;
                &:active {
                    background: #69a7ec url("~@/assets/imgs/bar_home_on.png") center 1rem / 1.6rem no-repeat;
                    span {
                        color: white;
                    }
                }
            }
            &.share_btn {
                background: url("~@/assets/imgs/bar_share.png") center 1rem / 1.6rem no-repeat;
                &:active {
                    background: #69a7ec url("~@/assets/imgs/bar_share_on.png") center 1rem / 1.6rem no-repeat;
                    span {
                        color: white;
                    }
                }
            }
            &.comment_btn {
                background: url("~@/assets/imgs/bar_comment.png") center 1rem / 1.6rem no-repeat;
                &:active {
                    background: #69a7ec url("~@/assets/imgs/bar_comment_on.png") center 1rem / 1.6rem no-repeat;
                    span {
                        color: white;
                    }
                }
            }
            &.statusbar_btn_show {
                background: url("~@/assets/imgs/bar_show_status.png") center 1rem / 1.6rem no-repeat;
                &:active {
                    background: #69a7ec url("~@/assets/imgs/bar_show_status_on.png") center 1rem / 1.6rem no-repeat;
                    span {
                        color: white;
                    }
                }
            }
            &.statusbar_btn_hide {
                background: url("~@/assets/imgs/bar_hide_status.png") center 1rem / 1.6rem no-repeat;
                &:active {
                    background: #69a7ec url("~@/assets/imgs/bar_hide_status_on.png") center 1rem / 1.6rem no-repeat;
                    span {
                        color: white;
                    }
                }
            }
            &.prev_btn {
                background: url("~@/assets/imgs/bar_prev.png") center 1rem / 1.6rem no-repeat;
                &:active {
                    background: #69a7ec url("~@/assets/imgs/bar_prev_on.png") center 1rem / 1.6rem no-repeat;
                    span {
                        color: white;
                    }
                }
            }
            &.proto_close {
                background: url("~@/assets/imgs/bar_proto_close.png") center 1rem / 1.6rem no-repeat;
                &:active {
                    background: #69a7ec url("~@/assets/imgs/bar_proto_close_on.png") center 1rem / 1.6rem no-repeat;
                    span {
                        color: white;
                    }
                }
            }

            span {
                position: absolute;
                bottom: 1rem;
                left: 0;
                width: 100%;
                text-align: center;
                font-size: 0.7rem;
                color: #69a7ec;
            }
        }
    }
}
.slider_bar_land {
    position: fixed;
    top: 0;
    left: 50%;
    margin-left: -6rem;
    height: 1.5rem;
    width: 12rem;
    border-radius: 0 0 0.3rem 0.3rem;
    background: rgba(255, 255, 255, 0.9);
    -webkit-transform: translateX(-100%);
    transform: translateY(-100%);
    z-index: 111;
    -webkit-transition: all ease 200ms;
    transition: all ease 200ms;

    &.show {
        transform: translateX(0);
        z-index: 2018;
    }
    ul {
        height: 1.5rem;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        .slide-item {
            width: 1.5rem;
            height: 1.5rem;
            box-sizing: border-box;
            position: relative;
            &.proto_home {
                background-image: url("~@/assets/imgs/bar_home.png");
                background-repeat: no-repeat;
                background-size: 50% 50%;
                background-position: 50% 18%;
                &:active {
                    background: #69a7ec url("~@/assets/imgs/bar_home_on.png") no-repeat;
                    background-size: 50% 50%;
                    background-position: 50% 18%;
                    span {
                        color: white;
                    }
                }
            }
            &.share_btn {
                background-image: url("~@/assets/imgs/bar_share.png");
                background-repeat: no-repeat;
                background-size: 50% 50%;
                background-position: 50% 18%;
                &:active {
                    background: #69a7ec url("~@/assets/imgs/bar_share_on.png") no-repeat;
                    background-size: 50% 50%;
                    background-position: 50% 18%;
                    span {
                        color: white;
                    }
                }
            }
            &.comment_btn {
                background-image: url("~@/assets/imgs/bar_comment.png");
                background-repeat: no-repeat;
                background-size: 50% 50%;
                background-position: 50% 18%;
                &:active {
                    background: #69a7ec url("~@/assets/imgs/bar_comment_on.png") no-repeat;
                    background-size: 50% 50%;
                    background-position: 50% 18%;
                    span {
                        color: white;
                    }
                }
            }
            &.statusbar_btn_hide {
                background-image: url("~@/assets/imgs/bar_hide_status.png");
                background-repeat: no-repeat;
                background-size: 50% 50%;
                background-position: 50% 18%;
                &:active {
                    background: #69a7ec url("~@/assets/imgs/bar_hide_status_on.png") no-repeat;
                    background-size: 50% 50%;
                    background-position: 50% 18%;
                    span {
                        color: white;
                    }
                }
            }
            &.statusbar_btn_show {
                background-image: url("~@/assets/imgs/bar_show_status.png");
                background-repeat: no-repeat;
                background-size: 50% 50%;
                background-position: 50% 18%;
                &:active {
                    background: #69a7ec url("~@/assets/imgs/bar_show_status_on.png") no-repeat;
                    background-size: 50% 50%;
                    background-position: 50% 18%;
                    span {
                        color: white;
                    }
                }
            }
            &.prev_btn {
                background-image: url("~@/assets/imgs/bar_prev.png");
                background-repeat: no-repeat;
                background-size: 50% 50%;
                background-position: 50% 18%;
                &:active {
                    background: #69a7ec url("~@/assets/imgs/bar_prev_on.png") no-repeat;
                    background-size: 50% 50%;
                    background-position: 50% 18%;
                    span {
                        color: white;
                    }
                }
            }
            &.proto_close {
                background-image: url("~@/assets/imgs/bar_proto_close.png");
                background-repeat: no-repeat;
                background-size: 50% 50%;
                background-position: 50% 18%;
                &:active {
                    background: #69a7ec url("~@/assets/imgs/bar_proto_close_on.png") no-repeat;
                    background-size: 50% 50%;
                    background-position: 50% 18%;
                    span {
                        color: white;
                    }
                }
            }

            span {
                position: absolute;
                bottom: 0.15rem;
                width: 1.5rem;
                text-align: center;
                font-size: 12px;
                color: #69a7ec;
            }
        }
    }
}
</style>
